import React, { useState, useEffect } from "react";

import PretendardText from "../pretendardText";

function TextBtn(props) {
  const [hover, setHover] = useState(false);

  return (
    <>
      <div
        onClick={props.onClick}
        onMouseEnter={() => setHover(true)} // 마우스엔터(호버)시 키값이 저장된다
        onMouseLeave={() => setHover(false)} // 마우스리브 시에는 키값이 지워진다
        style={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "row",
          opacity: hover ? "0.7" : "1",
          ...props.style,
        }}
      >
        {props.children}
      </div>
    </>
  );
}

export default TextBtn;
